import {Message} from 'element-ui'
import {getStore, setStore} from '../../../utils/store'
import {validatenull} from '../../../utils/validate'
import { getUserProfile } from '../../../api/userapi'

const user = {
    state: {
        userInfo: getStore({name: 'userInfo'}) || [],
    },
    actions: {
        //获取用户信息
        getUserProfile({commit}) {
           let promise =  new Promise((resolve, reject) => {
               getUserProfile().then(res => {
                   if (res.data.code == 200) {
                       commit('SET_USER_INFO', res.data.data);  //保存登录用户信息

                   } else {
                       Message.error("用户登录验证失败")
                   }
                   resolve();
               }).catch(err => {
                   reject(err);
               });


            });
            promise.catch(e=>{
            Message.error("用户登录验证失败")
           })
           return  promise;
        },


        // 登出
        LogOut({commit}) {
          return new Promise((resolve, reject) => {
              try{
                  // debugger
                  // console.log("logOut---------------------------------")
                  localStorage.removeItem("token")
                  localStorage.removeItem("menu")
                  window.localStorage.removeItem('userInfo')
                  resolve();
              }catch (err) {
                  reject(err);
              }



          })
        },
    },
    mutations: {
        SET_USER_INFO: (state, userInfo) => {
            if (validatenull(userInfo.avatar)) {
              userInfo.avatar = require('../../assets/logo.png');
            }
            state.userInfo = userInfo;
            setStore({name: 'userInfo', content: state.userInfo})
        },

    }
}
export default user
